<div class="page-body">
  <div>
    <header
    [breadcrumbPath]="breadcrumb"
    ></header>
    <div class="page-content" >
        <h2><tra slug="title_legal"></tra></h2>
        <markdown 
          class="markdown" 
          [data]="lang.tra('page_legal')" 
          ngPreserveWhitespaces
        ></markdown>

    </div>
  </div>
  <footer [hasLinks]="true"></footer>
</div>

